<script lang="ts">
  import { callWindow } from "./window-actions";
</script>

    <!-- Onboarding Guide Modal -->
    <div id="welcomeGuideModal" class="fixed inset-0 bg-black/90 flex items-center justify-center z-[100] hidden px-3 md:px-4" role="dialog" aria-modal="true" aria-labelledby="welcomeGuideTitle" aria-hidden="true" tabindex="-1" inert>
        <div data-modal-panel class="hunter-panel hunter-panel-framed max-w-lg md:max-w-xl w-full max-h-[calc(100dvh-2rem)] p-4 md:p-6 rounded shadow-2xl text-white flex flex-col gap-3 md:gap-4 overflow-hidden">
            <div class="text-center shrink-0">
                <h3 id="welcomeGuideTitle" class="cinzel text-xl md:text-2xl font-bold text-amber-400 tracking-wider"><i class="fa-solid fa-compass mr-1.5"></i> 수렵 탐사 가이드</h3>
                <p class="text-[10.5px] md:text-[12px] text-amber-100/70 mt-1">무너진 신대륙 가이아 전선에 합류합니다.</p>
            </div>

            <div class="bg-slate-950/90 p-3 md:p-4 rounded border border-amber-950/40 text-[11.5px] md:text-[13px] flex flex-col gap-3 leading-relaxed overflow-y-auto pr-2 md:pr-3 min-h-0">
                <div>
                    <span class="text-amber-400 font-bold tracking-wider"><i class="fa-solid fa-scroll mr-1"></i> 전선의 목적</span>
                    <p class="text-[10.5px] md:text-[12px] text-gray-300 mt-1 pl-2 md:pl-4">
                        가이아의 고대 거수들이 깨어나 전초기지를 위협합니다. 헌터는 필드를 정찰하고, 거수 소재를 회수하고, 대장간에서 장비를 완성해 더 깊은 생태권으로 진입합니다.
                    </p>
                </div>
                <hr class="border-amber-950/20">
                <div>
                    <span class="text-red-400 font-bold tracking-wider"><i class="fa-solid fa-gavel mr-1"></i> 전투 핵심</span>
                    <p class="text-[10.5px] md:text-[12px] text-gray-300 mt-1 pl-2 md:pl-4">
                        공격 중에도 발을 멈추지 않습니다. 거수의 사거리 밖으로 흘러나가며 직업별 3개 전술을 엮고, 체력과 재사용 대기를 보며 물약 사용 타이밍을 아껴야 합니다.
                    </p>
                </div>
                <hr class="border-amber-950/20">
                <div>
                    <span class="text-cyan-400 font-bold tracking-wider"><i class="fa-solid fa-map-location-dot mr-1"></i> 이동과 관문 증표</span>
                    <p class="text-[10.5px] md:text-[12px] text-gray-300 mt-1 pl-2 md:pl-4">
                        마을 중앙 관문은 무료 이동 거점입니다. 어디서든 바로 전송하려면 관문 옆 상인 아일라에게서 관문 증표를 구입해 1회 소모합니다. 고위험 지역은 레벨 조건을 먼저 요구합니다.
                    </p>
                </div>
                <hr class="border-amber-950/20">
                <div>
                    <span class="text-yellow-400 font-bold tracking-wider"><i class="fa-solid fa-hammer mr-1"></i> 성장 순서</span>
                    <p class="text-[10.5px] md:text-[12px] text-gray-300 mt-1 pl-2 md:pl-4">
                        먼저 대장간 브란의 지령을 받고 태고의 숲에서 벨로시랩터를 사냥하십시오. 보급단에서 물약을 챙기고, 소재를 모아 무기 제작, 방어구 세트, 강화, 전설 제련으로 다음 필드 난이도를 넘습니다.
                    </p>
                </div>
                <hr class="border-amber-950/20">
                <div>
                    <span class="text-rose-400 font-bold tracking-wider"><i class="fa-solid fa-users mr-1"></i> MMO 전선</span>
                    <p class="text-[10.5px] md:text-[12px] text-gray-300 mt-1 pl-2 md:pl-4">
                        같은 수렵망의 헌터들은 위치, 채팅, 내 위치 공개 상태를 공유합니다. 무법 콜로세움에서는 공정 판정 전술로 대련하고, 필드에서는 파티 흐름에 맞춰 생존과 기여도를 함께 관리합니다.
                    </p>
                </div>
            </div>

            <button type="button" onclick={() => callWindow("closeGuideAndStart")} class="w-full bg-gradient-to-r from-amber-500 via-amber-600 to-amber-700 hover:from-amber-400 text-slate-950 font-black text-sm md:text-base py-3 rounded shadow-lg transition-all tracking-wider cinzel shrink-0">
                전초 기지 진입하기
            </button>
        </div>
    </div>

    <!-- Beta Notice Modal -->
    <div id="betaNoticeModal" class="fixed inset-0 bg-black/90 flex items-center justify-center z-[101] hidden px-3 md:px-4" role="dialog" aria-modal="true" aria-labelledby="betaNoticeTitle" aria-hidden="true" tabindex="-1" inert>
        <div data-modal-panel class="hunter-panel hunter-panel-framed max-w-lg md:max-w-xl w-full max-h-[calc(100dvh-2rem)] p-4 md:p-5 rounded shadow-2xl text-white flex flex-col gap-3 overflow-hidden">
            <div class="text-center shrink-0">
                <div id="betaNoticeBadge" class="inline-flex items-center gap-1.5 rounded border border-amber-500/35 bg-slate-950/80 px-2.5 py-1 text-[10px] font-black text-amber-200 tracking-[0.18em] cinzel">BETA 0.3.0</div>
                <h3 id="betaNoticeTitle" class="cinzel text-xl md:text-2xl font-bold text-amber-400 tracking-wider mt-2"><i class="fa-solid fa-bullhorn mr-1.5"></i> 오픈 베타 안내</h3>
                <p id="betaNoticeSubtitle" class="text-[10.5px] md:text-[12px] text-amber-100/70 mt-1">공개 테스트 운영 안내입니다.</p>
            </div>

            <div id="betaNoticeBody" class="bg-slate-950/90 p-3 md:p-4 rounded border border-amber-950/40 text-[11.5px] md:text-[13px] leading-relaxed overflow-y-auto min-h-0">
                <p class="text-yellow-50 font-bold">BEAST HUNTER: Chronicles of Gaea 0.3.0 업데이트 안내입니다.</p>
                <p class="text-slate-300 mt-2">
                    전투에 관련 된 모든 시스템 및 시각적 효과 개편<br>
                    사냥터별 몬스터 개체 수 조정<br>
                    몬스터 종류 증가<br>
                    전체적인 UI 디자인 개선<br>
                    오류와 건의는
                    <span class="text-amber-300 font-bold">chojondocho@gmail.com</span> 또는 디시인사이드 <span class="text-amber-300 font-bold">특이점이 온다 갤러리</span>의 초존도초 방명록으로 보내 주십시오.
                </p>
                <p class="text-rose-100 mt-2 font-bold">
                    베타 기간에는 밸런스 조정과 서버 안정화를 위해 캐릭터 및 진행 데이터가 예고 없이 초기화될 수 있습니다.
                </p>
            </div>

            <label class="flex items-center justify-center gap-2 text-[11px] md:text-[12px] text-slate-300 font-bold select-none">
                <input id="betaNoticeSuppressToday" type="checkbox" class="accent-amber-500">
                <span id="betaNoticeSuppressLabel">오늘 하루 보지 않기</span>
            </label>
            <button type="button" onclick={() => callWindow("closeBetaNotice")} class="w-full bg-gradient-to-r from-amber-500 via-amber-600 to-amber-700 hover:from-amber-400 text-slate-950 font-black text-sm md:text-base py-3 rounded shadow-lg transition-all tracking-wider cinzel shrink-0">
                확인
            </button>
        </div>
    </div>
